import React from 'react';
import Button from '@material-ui/core/Button';
import { config as appConfig } from '../config';

import Container from './Container';

const RecordingButton = () => {
  return (
    <div className="recording-button-wrapper">
      <Button
        className="left-button red-button medium-font"
        id = "start-recording-button"
        variant="contained"
        href={`${appConfig.screenappFrontendBaseUrl}/#/recording`}      >
        Start Recording
      </Button>
    </div>
  );
};

export default RecordingButton;
